import type { Tone } from '../../ui/v2';

export type StoreSortKey =
  | 'id'
  | 'name'
  | 'city'
  | 'state'
  | 'timezone'
  | 'livemode'
  | 'takes_reservations'
  | 'accepts_deliveries'
  | 'accepts_phone_orders'
  | 'knowledge_base_id'
  | 'location_secondary_phone_number';

export const STORE_SORT_KEY_TO_FIELD: Record<StoreSortKey, string> = {
  id: 'id',
  name: 'name',
  city: 'city',
  state: 'state',
  timezone: 'timezone',
  livemode: 'livemode',
  takes_reservations: 'takes_reservations',
  accepts_deliveries: 'accepts_deliveries',
  accepts_phone_orders: 'accepts_phone_orders',
  knowledge_base_id: 'knowledge_base_id',
  location_secondary_phone_number: 'location_secondary_phone_number',
};

export interface StoreListRow {
  id: number;
  name: string;
  city?: string;
  state?: string;
  timezone?: string;
  knowledge_base_id?: string | null;
  livemode?: boolean;
  takes_reservations?: boolean;
  accepts_deliveries?: boolean;
  accepts_phone_orders?: boolean;
  location_secondary_phone_number?: string;
}

export type StoreFlagKey =
  | 'livemode'
  | 'takes_reservations'
  | 'accepts_deliveries'
  | 'accepts_phone_orders';

export type StoreTextKey =
  | 'city'
  | 'state'
  | 'timezone'
  | 'knowledge_base_id'
  | 'location_secondary_phone_number';

export type StoreColumn =
  | { kind: 'id'; label: string }
  | { kind: 'name'; label: string }
  | { kind: 'text'; key: StoreTextKey; label: string }
  | { kind: 'flag'; key: StoreFlagKey; label: string }
  | { kind: 'actions'; label: string };

export const STORE_COLUMNS: StoreColumn[] = [
  { kind: 'id', label: 'ID' },
  { kind: 'name', label: 'Name' },
  { kind: 'text', key: 'city', label: 'City' },
  { kind: 'text', key: 'state', label: 'State' },
  { kind: 'text', key: 'timezone', label: 'Timezone' },
  { kind: 'flag', key: 'livemode', label: 'Live' },
  { kind: 'flag', key: 'takes_reservations', label: 'Reservations' },
  { kind: 'flag', key: 'accepts_deliveries', label: 'Deliveries' },
  { kind: 'flag', key: 'accepts_phone_orders', label: 'Phone Orders' },
  { kind: 'text', key: 'knowledge_base_id', label: 'Knowledge Base' },
  {
    kind: 'text',
    key: 'location_secondary_phone_number',
    label: 'Secondary Phone',
  },
  { kind: 'actions', label: 'Actions' },
];

export const storeTextValue = (store: StoreListRow, key: StoreTextKey) =>
  store[key] || '—';

export const storeFlagLabel = (value: unknown) => (value ? 'Yes' : 'No');

export const storeFlagTone = (value: unknown): Tone =>
  value ? 'success' : 'neutral';

export const storeColumnSortKey = (
  column: StoreColumn,
): StoreSortKey | null => {
  switch (column.kind) {
    case 'id':
      return 'id';
    case 'name':
      return 'name';
    case 'text':
    case 'flag':
      return column.key;
    default:
      return null;
  }
};
